import { Button, Card, Form, FormProps, Input, Row, Select, Space } from 'antd';
import { ILibraryContentsFilter } from 'interfaces/libraries';
import { ITreeTag } from 'interfaces/epimetheus/tags';
import { useCan, useList } from '@refinedev/core';

const KIND_OPTIONS = [
  { value: 'video', label: 'Vídeo' },
  { value: 'audio', label: 'Áudio' },
  { value: 'document', label: 'Documento' },
  { value: 'hyper_doc', label: 'Hyper Doc' },
  { value: 'html_doc', label: 'HTML' },
  { value: 'image', label: 'Imagem' }
];

const flattenTags = (
  tags: ITreeTag[] = [],
  depth = 0
): { value: string; label: string }[] =>
  tags.flatMap(tag => [
    { value: tag.id, label: `${'— '.repeat(depth)}${tag.name}` },
    ...flattenTags(tag.tags, depth + 1)
  ]);

interface ContentsFilterProps {
  searchFormProps: FormProps<ILibraryContentsFilter>;
  libraryId: string;
}

export const ContentsFilter = ({
  searchFormProps,
  libraryId
}: ContentsFilterProps) => {
  const { data: canListTags } = useCan({
    resource: 'library_tags',
    action: 'list'
  });
  const hasTagsAccess = !!canListTags?.can;

  const { data: tagsData, isLoading: isLoadingTags } = useList<ITreeTag>({
    resource: `prometheus/v2/libraries/${libraryId}/tags`,
    pagination: { mode: 'off' },
    queryOptions: { enabled: !!libraryId && hasTagsAccess }
  });

  const tagOptions = flattenTags(tagsData?.data as ITreeTag[] | undefined);

  return (
    <Card className="filter-form-card p-2 mb-3" size="small">
      <Form {...searchFormProps} layout="horizontal">
        <Row
          align="middle"
          justify="start"
          wrap
          className="gap-4 [&>.ant-form-item]:mb-0"
        >
          <Form.Item name="q">
            <Input placeholder="Buscar por nome" className="lg:w-[300px]" />
          </Form.Item>

          <Form.Item name="id">
            <Input
              placeholder="Buscar por ID"
              className="lg:w-[300px]"
              allowClear
            />
          </Form.Item>

          <Form.Item name="kind">
            <Select
              allowClear
              placeholder="Todos os tipos"
              options={KIND_OPTIONS}
              className="lg:w-[300px]"
            />
          </Form.Item>

          {hasTagsAccess && (
            <Form.Item name="tag_ids">
              <Select
                mode="multiple"
                allowClear
                loading={isLoadingTags}
                placeholder="Tags"
                optionFilterProp="label"
                options={tagOptions}
                className="lg:w-[300px]"
              />
            </Form.Item>
          )}

          <Space className="ml-auto flex-shrink-0" wrap align="center">
            <Button
              type="default"
              onClick={() => {
                searchFormProps.form?.resetFields();
                searchFormProps.form?.submit();
              }}
            >
              Limpar filtro
            </Button>
            <Button type="primary" htmlType="submit" ghost>
              Filtrar
            </Button>
          </Space>
        </Row>
      </Form>
    </Card>
  );
};
